import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateRangeModel } from '../date-range-picker/date-range.model';

export class SaleSettingModel {
  constructor() {
    this.saleSubmission = new Array();
    this.saleSession = new Array();
    this.saleBreezeUp = new Array();
    this.saleDocumentTypeAccess = new Array();
  }
  public saleId: number;
  public accessionPrefix: string;
  public accessionExample: string;
  public repositoryLocation: string;
  public xrayCommenceDays?: number;
  public submissionStartDate?: any;
  public submissionEndDate?: any;
  public submissionEndDays?: number;
  public submissionDateRange?: DateRangeModel;
  public viewingStartDate?: any;
  public viewingEndDate?: any;
  public viewingEndDays?: number;
  public viewingDateRange?: DateRangeModel;
  public saleTemplateId: number;
  public xRays: boolean;
  public scopeVideo: boolean;
  public pdfReports: boolean;
  public termsAndConditionsUrl: string;
  public privacyPolicyUrl: string;
  public newUsersInstructionsViewing: string;
  public newUsersInstructionsSubmittingAStudy: string;
  public newUsersInstructionsNote: string;
  public isSubmissionAllowed: boolean;
  public isViewingAllowed: boolean;
  public saleSubmission: SaleSubmissionModel[];
  public saleSession: SaleSessionModel[];
  public saleBreezeUp: SaleBreezeUpModel[];
  public saleDocumentTypeAccess: SaleDocumentTypeAccess[];
  public lotOrHipText: string;
  public timeZone: string;
  public timeZoneIana: string;
  public isBreezeUpSale: boolean;
  public isScopeAllowedWithoutXrays: boolean;
  public isXrayRequiredForScopeSubmission: boolean;

  private static getDateForModel(date: Date): string {
    if (date instanceof Date) {
      var formatedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${date
        .getDate()
        .toString()
        .padStart(2, '0')}T00:00:00.000Z`;
      return formatedDate;
    }
    return date;
  }

  static asFormGroup(setting: SaleSettingModel): FormGroup {
    const abstractControlSaleSubmission = setting.saleSubmission.map(
      SaleSubmissionModel.asFormGroup
    );
    const abstractControlSaleSession = setting.saleSession.map(
      SaleSessionModel.asFormGroup
    );
    const abstractControlSaleBreezeUp = setting.saleBreezeUp.map(
      SaleBreezeUpModel.asFormGroup
    );

    const abstractControlSaleDocumentTypeAccess =
      setting.saleDocumentTypeAccess.map(SaleDocumentTypeAccess.asFormGroup);

    if (!setting.submissionStartDate) {
      setting.submissionStartDate = new Date();
    }
    if (!setting.submissionEndDate) {
      setting.submissionEndDate = new Date();
    }
    if (!setting.viewingStartDate) {
      setting.viewingStartDate = new Date();
    }
    if (!setting.viewingEndDate) {
      setting.viewingEndDate = new Date();
    }
    const sDateRange: DateRangeModel = DateRangeModel.ToDateRange(
      setting.submissionStartDate,
      setting.submissionEndDate
    );
    const vDateRange: DateRangeModel = DateRangeModel.ToDateRange(
      setting.viewingStartDate,
      setting.viewingEndDate
    );
    const fg = new FormGroup({
      saleId: new FormControl(setting.saleId),
      accessionPrefix: new FormControl(setting.accessionPrefix),
      accessionExample: new FormControl(setting.accessionExample),
      repositoryLocation: new FormControl(setting.repositoryLocation),
      xrayCommenceDays: new FormControl(setting.xrayCommenceDays),
      submissionStartDate: new FormControl(
        SaleSettingModel.getDateForModel(setting.submissionStartDate)
      ),
      submissionEndDate: new FormControl(
        SaleSettingModel.getDateForModel(setting.submissionEndDate)
      ),
      submissionDateRange: new FormControl(sDateRange),
      viewingStartDate: new FormControl(
        SaleSettingModel.getDateForModel(setting.viewingStartDate)
      ),
      viewingEndDate: new FormControl(
        SaleSettingModel.getDateForModel(setting.viewingEndDate)
      ),
      viewingDateRange: new FormControl(vDateRange),
      saleTemplateId: new FormControl(setting.saleTemplateId),
      xRays: new FormControl(setting.xRays),
      isXrayRequiredForScopeSubmission: new FormControl(setting.isXrayRequiredForScopeSubmission),
      scopeVideo: new FormControl(setting.scopeVideo),
      pdfReports: new FormControl(setting.pdfReports),
      termsAndConditionsUrl: new FormControl(setting.termsAndConditionsUrl, [
        Validators.pattern('https?://.+'),
        Validators.required,
      ]),
      privacyPolicyUrl: new FormControl(setting.privacyPolicyUrl, [
        Validators.pattern('https?://.+'),
        Validators.required,
      ]),
      newUsersInstructionsViewing: new FormControl(
        setting.newUsersInstructionsViewing
      ),
      newUsersInstructionsSubmittingAStudy: new FormControl(
        setting.newUsersInstructionsSubmittingAStudy
      ),
      newUsersInstructionsNote: new FormControl(
        setting.newUsersInstructionsNote
      ),
      saleSubmission: new FormArray(abstractControlSaleSubmission),
      saleSession: new FormArray(abstractControlSaleSession),
      saleBreezeUp: new FormArray(abstractControlSaleBreezeUp),
      saleDocumentTypeAccess: new FormArray(
        abstractControlSaleDocumentTypeAccess
      ),
    });
    return fg;
  }
}
export class SaleSessionModel {
  public saleSessionId: number;
  public saleId: number;
  public startDate: Date;
  public endDate: Date;
  public bookNumber: number;
  public sessionNumber: number;
  public minLotNumber?: number;
  public maxLotNumber?: number;
  public breezeDate?: Date;
  public xRayCommenceDate?: Date;
  public xRayCompletedDate?: Date;
  public xrayScopeTaken?: Date;
  public xrayScopeVisible?: Date;
  private static getDateForModel(date: Date): string {
    if (date instanceof Date) {
      var formatedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${date
        .getDate()
        .toString()
        .padStart(2, '0')}T00:00:00.000Z`;
      return formatedDate;
    }
    return date;
  }
  static asFormGroup(saleSession: SaleSessionModel) {
    if (!saleSession.xRayCommenceDate) {
      saleSession.xRayCommenceDate = new Date();
    }
    if (!saleSession.xRayCompletedDate) {
      saleSession.xRayCompletedDate = new Date();
    }
    if (!saleSession.breezeDate) {
      saleSession.breezeDate = new Date();
    }
    if (!saleSession.xrayScopeTaken) {
      saleSession.xrayScopeTaken = new Date();
    }

    if (!saleSession.xrayScopeVisible) {
      saleSession.xrayScopeVisible = new Date();
    }
    const fg = new FormGroup({
      saleSessionId: new FormControl(saleSession.saleSessionId),
      saleId: new FormControl(saleSession.saleId),
      startDate: new FormControl(saleSession.startDate),
      endDate: new FormControl(saleSession.endDate),
      bookNumber: new FormControl(saleSession.bookNumber),
      sessionNumber: new FormControl(saleSession.sessionNumber),
      minLotNumber: new FormControl(saleSession.minLotNumber),
      maxLotNumber: new FormControl(saleSession.maxLotNumber),
      breezeDate: new FormControl(
        SaleSessionModel.getDateForModel(saleSession.breezeDate)
      ),
      xRayCommenceDate: new FormControl(
        SaleSessionModel.getDateForModel(saleSession.xRayCommenceDate)
      ),
      xRayCompletedDate: new FormControl(
        SaleSessionModel.getDateForModel(saleSession.xRayCompletedDate)
      ),
      xrayScopeTaken: new FormControl(
        SaleSessionModel.getDateForModel(saleSession.xrayScopeTaken)
      ),
      xrayScopeVisible: new FormControl(
        SaleSessionModel.getDateForModel(saleSession.xrayScopeVisible)
      ),
    });
    return fg;
  }
}
export class SaleBreezeUpModel {
  public id: number;

  public saleDateTime: Date;
  public bookNumber: number;
  public sessionNumber: number;
  public minLotNumber?: number;
  public maxLotNumber?: number;
  public breezeDateTime?: Date;
  public xrayScopeTaken?: Date;
  public xrayScopeVisible?: Date;
  private static getDateForModel(date: Date): string {
    if (date instanceof Date) {
      var formatedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${date
        .getDate()
        .toString()
        .padStart(2, '0')}T00:00:00.000Z`;
      return formatedDate;
    }
    return date;
  }
  static asFormGroup(saleSession: SaleBreezeUpModel) {
    if (!saleSession.saleDateTime) {
      saleSession.saleDateTime = new Date();
    }
    if (!saleSession.breezeDateTime) {
      saleSession.breezeDateTime = new Date();
    }
    if (!saleSession.xrayScopeTaken) {
      saleSession.xrayScopeTaken = new Date();
    }
    if (!saleSession.xrayScopeVisible) {
      saleSession.xrayScopeVisible = new Date();
    }

    /**
     * public id: number;
  
  public saleDateTime: Date;
  public bookNumber: number;
  public sessionNumber: number;
  public minLotNumber?: number;
  public maxLotNumber?: number;
  public breezeDateTime?: Date;
  public ?: Date;
  public xRayScopeVisible?: Date;
     */
    const fg = new FormGroup({
      id: new FormControl(saleSession.id),
      saleDateTime: new FormControl(saleSession.saleDateTime),
      bookNumber: new FormControl(saleSession.bookNumber),
      sessionNumber: new FormControl(saleSession.sessionNumber),
      minLotNumber: new FormControl(saleSession.minLotNumber),
      maxLotNumber: new FormControl(saleSession.maxLotNumber),
      breezeDateTime: new FormControl(saleSession.breezeDateTime),
      xrayScopeTaken: new FormControl(saleSession.xrayScopeTaken),
      xrayScopeVisible: new FormControl(saleSession.xrayScopeVisible),

      // breezeDate: new FormControl(
      //   SaleBreezeUpModel.getDateForModel(saleSession.breezeDate)
      // ),
      // xRayCommenceDate: new FormControl(
      //   SaleBreezeUpModel.getDateForModel(saleSession.xRayCommenceDate)
      // ),
      // xRayCompletedDate: new FormControl(
      //   SaleBreezeUpModel.getDateForModel(saleSession.xRayCompletedDate)
      // ),
      // xRayCompletedDate: new FormControl(
      //   SaleBreezeUpModel.getDateForModel(saleSession.xRayCompletedDate)
      // ),
    });
    return fg;
  }

  static newFormGroup() {
    const fg = new FormGroup({
      id: new FormControl(0),
      saleDateTime: new FormControl(this.getDateForModel(new Date()), [
        Validators.required,
      ]),
      bookNumber: new FormControl(null, [Validators.required]),
      sessionNumber: new FormControl(null, [Validators.required]),
      minLotNumber: new FormControl(null, [Validators.required]),
      maxLotNumber: new FormControl(null, [Validators.required]),
      breezeDateTime: new FormControl(this.getDateForModel(new Date()), [
        Validators.required,
      ]),
      xrayScopeTaken: new FormControl(this.getDateForModel(new Date()), [
        Validators.required,
      ]),
      xrayScopeVisible: new FormControl(this.getDateForModel(new Date()), [
        Validators.required,
      ]),
    });

    return fg;
  }
}
export class SaleDocumentTypeAccess {
  documentTypeId: number;
  saleDocumentTypeName: string;
  isVisibleToVetViewer: boolean;
  isEnforceOpenBeforeXrayImages: boolean;
  static asFormGroup(docType: SaleDocumentTypeAccess): FormGroup {
    const fg = new FormGroup({
      documentTypeId: new FormControl(docType.documentTypeId),
      isVisibleToVetViewer: new FormControl(docType.isVisibleToVetViewer),
      isEnforceOpenBeforeXrayImages: new FormControl(
        docType.isEnforceOpenBeforeXrayImages
      ),
      saleDocumentTypeName: new FormControl(docType.saleDocumentTypeName),
    });
    return fg;
  }
}

export class SaleSubmissionModel {
  constructor() {}
  public saleSubmissionId: number;
  public saleId: number;
  public horseAgeCategoryId: number;
  public horseAgeCategoryName: string;
  public xrayCompleteType: number;
  public isXRayReport: boolean;
  public isScope: boolean;
  public isActive: boolean;
  public saleTemplateId: number;
  public scopeReport: boolean;
  public isAutoApproveSubmissions: boolean;
  static asFormGroup(submission: SaleSubmissionModel): FormGroup {
    if (!submission.saleTemplateId) {
      submission.saleTemplateId = 0;
    }
    const fg = new FormGroup({
      saleSubmissionId: new FormControl(submission.saleSubmissionId),
      saleId: new FormControl(submission.saleId),
      horseAgeCategoryId: new FormControl(submission.horseAgeCategoryId),
      horseAgeCategoryName: new FormControl(submission.horseAgeCategoryName),
      xrayCompleteType: new FormControl({
        value: submission.xrayCompleteType,
        disabled: !submission.isActive,
      }),
      isXRayReport: new FormControl({
        value: submission.isXRayReport,
        disabled: !submission.isActive,
      }),
      isScope: new FormControl({
        value: submission.isScope,
        disabled: !submission.isActive,
      }),
      isActive: new FormControl(submission.isActive),
      saleTemplateId: new FormControl(submission.saleTemplateId),
      scopeReport: new FormControl({
        value: submission.scopeReport,
        disabled: !submission.isActive,
      }),

      isAutoApproveSubmissions: new FormControl({
        value: submission.isAutoApproveSubmissions,
        disabled: !submission.isActive,
      }),
    });
    return fg;
  }
}

export class NewBreezeUpModal {
  bookNumber: number;
  sessionNumber: number;
  saleDate: Date;
  firstHip: number;
  lastHip: number;
}
